// import app component classes
import { ScreenContainer } from './screen-container/screen-container'
import { TransitionContainer } from './transition-container/transition-container'
import { LandingScreen } from './landing-screen/landing-screen'
import { HeroImage } from './hero-image/hero-image'
import { PoseImage } from './pose-image/pose-image'
import { CoverImage } from './cover-image/cover-image'
import { StickerImage } from './sticker-image/sticker-image'
import { BodypartImage } from './bodypart-image/bodypart-image'
import { ShieldInterface } from './shield-interface/shield-interface'
import { HeaderBar } from './header-bar/header-bar'
import { GenderScreen } from './gender-screen/gender-screen'
import { CreatorScreen } from './creator-screen/creator-screen'
import { PoseScreen } from './pose-screen/pose-screen'
import { ComicScreen } from './comic-screen/comic-screen'
import { DownloadScreen } from './download-screen/download-screen'
import { ShareScreen } from './share-screen/share-screen'
import { BrandingScreen } from './branding-screen/branding-screen'
import { IntroScreen } from './intro-screen/intro-screen'
import { BodyMapMale } from './body-map-male/body-map-male'
import { BodyMapFemale } from './body-map-female/body-map-female'
import { StartButton } from './start-button/start-button'


// bundle component classes into angular components
export default angular.module('app.components', [])
  .component('screenContainer', new ScreenContainer())
  .component('transitionContainer', new TransitionContainer())
  .component('landingScreen', new LandingScreen())
  .component('heroImage', new HeroImage())
  .component('poseImage', new PoseImage())
  .component('coverImage', new CoverImage())
  .component('stickerImage', new StickerImage())
  .component('bodypartImage', new BodypartImage())
  .component('shieldInterface', new ShieldInterface())
  .component('headerBar', new HeaderBar())
  .component('genderScreen', new GenderScreen())
  .component('creatorScreen', new CreatorScreen())
  .component('poseScreen', new PoseScreen())
  .component('comicScreen', new ComicScreen())
  .component('downloadScreen', new DownloadScreen())
  .component('shareScreen', new ShareScreen())
  .component('brandingScreen', new BrandingScreen())
  .component('introScreen', new IntroScreen())
  .component('bodyMapMale', new BodyMapMale())
  .component('bodyMapFemale', new BodyMapFemale())
  .component('startButton', new StartButton())
  .animation('.hero-image__container', function () {
    return {
      addClass: function (element, className, done) {
        if(element[0].className.indexOf('female') !== -1){
          if(element[0].className.indexOf('standing') !== -1){
            // female standing
            switch (className) {
              case 'head':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '42% 15%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'torso':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '45% 25%',
                  scale: 3.5,
                  ease: Power1.easeOut,
                  onComplete: done
                })
                break
              case 'armUpperLeft':
                TweenMax.to(element, 0.3, {
                  transformOrigin: '55% 31%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armUpperRight':
                TweenMax.to(element, 0.3, {
                  transformOrigin: '33% 31%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armLowerLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '62% 45%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armLowerRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '30% 43%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'handLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '62% 52%',
                  scale: 6,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'handRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '33% 50%',
                  scale: 6,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legUpperLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '50% 60%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legUpperRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '38% 57%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legLowerLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '65% 85%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legLowerRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '38% 83%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'footLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '72% 95%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'footRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '32% 92%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              default:
                done();
                break;
            }
          } else {
            // female swinging
            switch (className) {
              case 'head':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '44% 22%',
                  scale: 3.5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'torso':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '35% 50%',
                  scale: 2.5,
                  ease: Power1.easeOut,
                  onComplete: done
                })
                break
              case 'armUpperLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '53% 32%',
                  scale: 3.5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armUpperRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '12% 50%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armLowerLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '57% 32%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armLowerRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '8% 50%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'handLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '75% 32%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'handRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '5% 50%',
                  scale: 5.5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legUpperLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '50% 67%',
                  scale: 3,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legUpperRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '38% 57%',
                  scale: 3,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legLowerLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '90% 75%',
                  scale: 3,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legLowerRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '58% 65%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'footLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '97% 65%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'footRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '70% 60%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              default:
                done();
                break;
            }
          }
        } else {
          // male standing
          if(element[0].className.indexOf('standing') !== -1){
            switch (className) {
              case 'head':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '52% 10%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'torso':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '52% 22%',
                  scale: 3.5,
                  ease: Power1.easeOut,
                  onComplete: done
                })
                break
              case 'armUpperLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '65% 28%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armUpperRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '38% 25%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armLowerLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '67% 40%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armLowerRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '33% 40%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'handLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '67% 50%',
                  scale: 6,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'handRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '35% 50%',
                  scale: 6,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legUpperLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '60% 55%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legUpperRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '45% 55%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legLowerLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '65% 80%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legLowerRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '35% 85%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'footLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '65% 90%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'footRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '30% 92%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              default:
                done();
                break;
            }
          } else {
            // male swinging
            switch (className) {
              case 'head':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '55% 18%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'torso':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '65% 30%',
                  scale: 2.5,
                  ease: Power1.easeOut,
                  onComplete: done
                })
                break
              case 'armUpperLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '85% 35%',
                  scale: 3.5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armUpperRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '35% 20%',
                  scale: 3,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armLowerLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '90% 43%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'armLowerRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '20% 20%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'handLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '96% 44%',
                  scale: 5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'handRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '7% 18%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legUpperLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '57% 63%',
                  scale: 3,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legUpperRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '50% 75%',
                  scale: 3,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legLowerLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '47% 60%',
                  scale: 3,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'legLowerRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '17% 80%',
                  scale: 3,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'footLeft':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '25% 60%',
                  scale: 4.5,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              case 'footRight':
                TweenMax.to(element, 0.5, {
                  transformOrigin: '0% 60%',
                  scale: 4,
                  ease: Power1.easeOut,
                  onComplete: done
                });
                break;
              default:
                done();
                break;
            }
          }
        }


      },
      removeClass: function (element, className, done) {
        TweenMax.to(element, 0.5, {
          scale: 1,
          ease: Power1.easeOut,
          onComplete: done
        });
      }
    }
  })
  .animation('.transition-container__panel', function () {
    return {
      addClass: function (element, className, done) {
        switch (className) {
          case 'closeLeft':
            TweenMax.to(element, 0.5, {
              left: '0%',
              ease: Power3.easeIn,
              onComplete: done
            });
            break;
          case 'closeRight':
            TweenMax.to(element, 0.5, {
              right: '0%',
              ease: Power3.easeIn,
              onComplete: done
            });
            break;
          default:
            done();
            break;
        }
      },
      removeClass: function (element, className, done) {
        switch (className) {
          case 'closeLeft':
            TweenMax.to(element, 0.5, {
              left: '-50%',
              ease: Power3.easeIn,
              onComplete: done
            });
            break;
          case 'closeRight':
            TweenMax.to(element, 0.5, {
              right: '-50%',
              ease: Power3.easeIn,
              onComplete: done
            });
            break;
          default:
            done();
            break;
        }
      }
    }
  })
  .animation('.collapsable-left', function () {
    return {
      addClass: function (element, className, done) {
        switch (className) {
          case 'closed':
            TweenMax.to(element, 0.5, {
              left: '-33.33%',
              ease: Power0.easeIn,
              onComplete: done
            });
            break;
          default:
            done();
            break;
        }
      },
      removeClass: function (element, className, done) {
        switch (className) {
          case 'closed':
            TweenMax.to(element, 0.5, {
              left: '0%',
              ease: Power0.easeIn,
              onComplete: done
            });
            break;
          default:
            done();
            break;
        }
      }
    }
  })
  .animation('.collapsable-right', function () {
    return {
      addClass: function (element, className, done) {
        switch (className) {
          case 'expanded':
            TweenMax.to(element, 0.5, {
              width: '100%',
              ease: Power0.easeIn,
              onComplete: done
            });
            break;
          default:
            done();
            break;
        }
      },
      removeClass: function (element, className, done) {
        switch (className) {
          case 'expanded':
            TweenMax.to(element, 0.5, {
              width: '66.66%',
              ease: Power0.easeIn,
              onComplete: done
            });
            break;
          default:
            done();
            break;
        }
      }
    }
  })
  .animation('.creator-screen__sidebar__contents', function () {
    return {
      addClass: function (element, className, done) {
        switch (className) {
          case 'slideLeft':
            TweenMax.to(element, 0.15, {
              left: '-=101%',
              ease: Power0.easeIn,
              onComplete: done
            });
            break;
          default:
            done();
            break;
        }
      },
      removeClass: function (element, className, done) {
        switch (className) {
          case 'slideLeft':
            TweenMax.to(element, 0.15, {
              left: '+=101%',
              ease: Power0.easeIn,
              onComplete: done
            });
            break;
          default:
            done();
            break;
        }
      }
    }
  })
  .animation('.comic-screen__sidebar__contents', function () {
    return {
      addClass: function (element, className, done) {
        switch (className) {
          case 'slideLeft':
            TweenMax.to(element, 0.5, {
              left: '-=100%',
              ease: Power2.easeInOut,
              onComplete: done
            });
            break;
          default:
            done();
            break;
        }
      },
      removeClass: function (element, className, done) {
        switch (className) {
          case 'slideLeft':
            TweenMax.to(element, 0.5, {
              left: '+=100%',
              ease: Power2.easeInOut,
              onComplete: done
            });
            break;
          default:
            done();
            break;
        }
      }
    }
  })
  .directive('webfontLoader', ['$rootScope', '$window',
    function ($rootScope, $window) {
      return {
        link: function (scope, elem, attrs) {

          function onActive() {
            $rootScope.$broadcast('webfontLoader.loaded');
          }

          function onInactive() {
            $rootScope.$broadcast('webfontLoader.error');
          }

          let WebFont:any = require('webfontloader');

          WebFont.load({
            google: {
              families: [attrs.webfontLoader]
            },
            active: onActive,
            inactive: onInactive
          });
        }
      }
    }
  ])
  .directive('parentHoverClass', [function () {
    return {
      restrict: 'A',
      scope: {
        parentHoverClass: '@'
      },
      link: function (scope, element) {
        element.on('mouseenter', function() {
          angular.element(element).parent().addClass(scope.parentHoverClass);
        });
        element.on('mouseleave', function() {
          angular.element(element).parent().removeClass(scope.parentHoverClass);
        });
      }
    };
  }]);



/** WEBPACK FOOTER **
 ** ./src/components/components.ts
 **/